import clsx from 'clsx';

interface PillButtonProps extends React.ComponentProps<'button'> {
  children: React.ReactNode;
  active?: boolean;
  className?: string;
}

export function PillButton({ children, active, className, ...rest }: PillButtonProps) {
  const classes = clsx(
    'w-[max-content] rounded-full border border-gray-5 px-4 py-2 font-bold text-input-label transition-color duration-200',
    active ? 'text-white bg-black border-transparent' : 'hover:bg-gray-5 hover:border-transparent',
    className,
  );

  return (
    <button className={classes} {...rest}>
      {children}
    </button>
  );
}
